import * as ActionTypes from 'store/actionTypes';

const defaultState = {
    fromPhishingView:false
}

const phishingCampaignView = (state = defaultState, action: any) => {
  switch(action.type) {
    case ActionTypes.SAVE_PHISHING_RESULTS_VIEW:
      var ManagePhishingView = action.payload;
      return ({...state, ...ManagePhishingView});

    default:
      return state;
  }
}

export default phishingCampaignView;